import { defineStore } from 'pinia';
import { ServiceAlert } from '~~/data/resources/ServiceAlert';

const FRESH_FOR_MS = 1000;

interface ServiceAlertsState {
  alerts: ServiceAlert[];
  fetchedAt: number;
  isLoading: boolean;
}

export const useServiceAlerts = defineStore('serviceAlerts', {
  state: (): ServiceAlertsState => ({
    alerts: [],
    fetchedAt: 0,
    isLoading: false,
  }),

  getters: {
    alertCount: (state) => state.alerts.length,

    hasAlerts: (state) => state.alerts.length > 0,
  },

  actions: {
    async fetchIfStale(force = false): Promise<void> {
      if (this.isLoading) {
        return;
      }

      if (!force && Date.now() - this.fetchedAt < FRESH_FOR_MS) {
        return;
      }

      this.isLoading = true;
      try {
        this.alerts = await new ServiceAlert().listActive();
        this.fetchedAt = Date.now();
      } catch (error) {
        this.alerts = [];
      } finally {
        this.isLoading = false;
      }
    },
  },
});
